import { axiosBase } from 'utils';

export function emailSendLogListService(params = {}) {
  const axios = axiosBase.create();
  const query = new URLSearchParams();
  if (params.branch_network)
    query.append('branch_network', params.branch_network);
  if (params.email_type) query.append('email_type', params.email_type);
  if (params.from) query.append('from', params.from);
  if (params.to) query.append('to', params.to);
  const qs = query.toString();
  return axios({
    method: 'GET',
    url: qs ? `/email-send-log?${qs}` : '/email-send-log',
  });
}

/** WiFi details email logs for current client (e.g. WiFi user form). Optional branch_network id. */
export function emailSendLogWifiDetailsService(branchNetworkId) {
  const axios = axiosBase.create();
  const qs = branchNetworkId ? `?branch_network=${branchNetworkId}` : '';
  return axios({
    method: 'GET',
    url: `/email-send-log/wifi-details${qs}`,
  });
}
